module.exports = __webpack_public_path__ + "static/media/bye.e5733f1d.svg";